import { render, staticRenderFns } from "./formulaBuilder.vue?vue&type=template&id=4ea4dcef&scoped=true"
import script from "./formulaBuilder.vue?vue&type=script&lang=js"
export * from "./formulaBuilder.vue?vue&type=script&lang=js"
import style0 from "./formulaBuilder.vue?vue&type=style&index=0&id=4ea4dcef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea4dcef",
  null
  
)

export default component.exports